import React, {useEffect, useState} from 'react';
import {toast} from "react-toastify";
import StationAPI from "../../apis/stationApi/StationAPI";
import Field from "../forms/Field";
import MyButton from "../assets/MyButton";
import Select from "../forms/Select";
import BusesAPI from "../../apis/adminApi/busAPI";
import {useNavigate} from "react-router-dom";


const StoreConsumption = () => {

    const [showLoader, setShowLoader] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [setting, setSetting] = useState([]);
    const [buses, setBuses] = useState([]);
    const [drivers, setDrivers] = useState([]);

    const [stationConsumption, setStationConsumption] = useState({
        plaque : "", driver : "", motif : "" , quantity : "", type : ""
    });

    const [errors, setErrors] = useState({
        plaque : "", driver : "", motif : "", quantity : "", type: ""
    });

    const fetchSetting = async () => {
        try{
            const data =  await StationAPI.findSetting();
            setSetting(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des paramettres !");
        }
    };

    const fetchBuses = async () => {
        try{
            const data =  await StationAPI.findAllBuses();
            setBuses(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des buses !");
        }
    };

    const fetchDrivers = async () => {
        try{
            const data =  await StationAPI.findAllDrivers();
            setDrivers(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des chauffeurs !");
        }
    };



    useEffect(() => {
        fetchSetting();
        fetchBuses();
        fetchDrivers();
        return () => console.log("");
    },[]);



    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setStationConsumption({...stationConsumption, [name] : value});
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{
            setShowLoader(true);
            await StationAPI.storeConsumption(stationConsumption);
            setTimeout(() => setShowLoader(false), 100);
            toast.success("Appro ajouté avec succès");
            navigate("/station/dailyConsumption");
        }catch({response}){
            const {violations} = response.data;
            setTimeout(() => setShowLoader(false), 100);

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });
                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire d'ajout de l'appro !");
            }

            // const {message} = response.data;
            // const {attribute} = response.data;
            // if(attribute === "amount"){
            //     setErrors({"amount" : message});
            //     toast.error(message);
            // }
            // if(attribute === "source"){
            //     setErrors({"source" : message});
            //     toast.error(message);
            // }
        }
    };



    return <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-6">

                <div className="card">
                    <form onSubmit={handleSubmit} className="needs-validation">
                        <div className="card-body">
                            <h3 className="text-success fw-bold p-2">Enregistrer une consommation</h3>
                            <hr/>

                            <label htmlFor="plaque" className="form-label">Plaque</label>
                            {!loading &&
                                <select
                                    className={"form-select-sm form-control mb-2 " + ( errors.plaque && "is-invalid")}
                                    //size={(buses.length)}
                                    name="plaque"
                                    id="plaque"
                                    value={stationConsumption.plaque}
                                    onChange={handleChange}
                                >

                                    <option value="">Choisir...</option>
                                    {buses && buses.map((bus) => (
                                        <option key={bus.id} value={bus.bus_numberplate}>
                                            {bus.bus_numberplate}</option>
                                    ))
                                    }
                                </select>
                            }
                            {errors.plaque && <div className="invalid-feedback mb-4">{errors.plaque}</div>}

                            <label htmlFor="driver" className="form-label">Chauffeur</label>
                            {!loading &&
                                <select
                                    className={"form-select-sm form-control mb-2 " + ( errors.driver && "is-invalid")}
                                    //size={(buses.length)}
                                    name="driver"
                                    id="driver"
                                    value={stationConsumption.driver}
                                    onChange={handleChange}
                                >

                                    <option value="">Choisir...</option>
                                    {drivers && drivers.map((dr) => (
                                        <option key={dr.id} value={dr.name}>
                                            {dr.name}</option>
                                    ))
                                    }
                                </select>
                            }
                            {errors.driver && <div className="invalid-feedback mb-4">{errors.driver}</div>}


                            <Field
                                name="motif"
                                error={errors.motif}
                                value={stationConsumption.motif}
                                onChange={handleChange}
                                label="Motif"
                                autoComplete="off"
                            />
                            <hr/>

                           <div className="row">
                               <div className="col">
                                   <Field
                                       name="quantity"
                                       type="number"
                                       error={errors.quantity}
                                       value={stationConsumption.quantity}
                                       onChange={handleChange}
                                       label="Quantité en littre"
                                       placeholder="000"
                                   />
                               </div>
                               <div className="col">
                                   <Select name="type" label="Type"
                                           value={stationConsumption.type} error={errors.type}
                                           onChange={handleChange}>
                                       <option value="">Choisir...</option>
                                       <option value="Essence">Essence</option>
                                       <option value="Mazoute">Mazoute</option>
                                   </Select>
                                   {errors.type && <div className="invalid-feedback mb-4">{errors.type}</div>}
                               </div>
                           </div>

                            <MyButton
                                text="Enregistrer"
                                onSubmit={handleSubmit}
                                loading={showLoader}
                                disabled={showLoader}
                            />
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>;
};

export default StoreConsumption;
